

































































































































































































































































































































































































































































import {
  homeworkAdd,
  classList,
  classStudentList,
  lessonList,
  lessonStudentList,
} from "@/api/homework";
import {
  searchStudent,
  getSelectClassList,
  autoSearchData,
} from "@/api/globalSearch";
import { Component, Prop, Vue } from "vue-property-decorator";
import uploadBox from "./uploadBox.vue";
import eventBus from "@/utils/bus";
import { dateFormat } from "@/utils/timeFormat";
@Component({
  name: "leaceAppliDetails",
  components: {
    uploadBox,
  },
})
export default class extends Vue {
  lessonChildList = [];
  lessonId: number = -1; // 用来判断是否相等
  lessonChecked: boolean = false;
  deadendTime: any = 0; // 截止时间
  searchInfo = {
    title: "",
    type: "",
    publish_type: 1,
    deadlineTime: "", // 截止时间
    content_list: [],
    class_students: [
      {
        lesson_id: 0,
      },
    ],
  };
  student_type = [
    { value: "学员类", key: 1 },
    { value: "课次类", key: 2 },
  ];
  studentName = "";
  expireTimeClass = "";
  LessonList = [];
  rules = {
    title: [{ required: true, message: "请输入练习名称", trigger: "blur" }],
    type: [{ required: true, message: "请选择发布类型", trigger: "change" }],
    publish_type: [{ required: true, message: "请选择发布时间" }],
    deadlineTime: [{ required: true, message: "请选择截止时间" }],
  };
  choosestudent = false;
  choosestudenttwo = false;
  checkprops = {
    label: "name",
    isLeaf: "leaf",
  };
  checkpropstwo = {
    label: "class_name",
    isLeaf: "leaf",
  };
  checkboxData: any = [];
  checkboxDatatwo = [];
  classListPage = 1;
  lessionListPage = 1;
  loading = false;
  class_name = "";
  dialogClassId = "";
  className = "";
  expireTime = [];
  start_time = "";
  end_time = "";
  allpeople = 0;
  allchoose = [];
  jumpList = []; // 跳转过来选中的人数
  cuttentTime: any = "";
  studentData = [];
  tableData = [];
  jumpLessonId: number = 0; // 跳转过来的lessonId
  pageInfoWidth = 1727;
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  selectedObject: any = {};
  pickerOptions = {
    onPick: ({ maxDate, minDate }: any) => {
      this.cuttentTime = minDate.getTime();
      if (maxDate) {
        this.cuttentTime = "";
      }
    },
    disabledDate: (time: any) => {
      if (this.cuttentTime != "") {
        const one = 30 * 24 * 3600 * 1000;
        const minTime = this.cuttentTime - one;
        const maxTime = this.cuttentTime + one;
        return time.getTime() < minTime || time.getTime() > maxTime;
      }
    },
  };
  expireTimeOption = {
    disabledDate: (time: any) => {
      // Math.floor(Date.now() / 1000)
      // Date.now()- (1 * 24 * 3600 * 1000)
      return time.getTime() < Date.now() - 1 * 24 * 3600 * 1000;
    },
  };
  deadlineTimeOption = {
    disabledDate: (time: any) => {
      // Math.floor(Date.now() / 1000)
      // Date.now()- (1 * 24 * 3600 * 1000)
      return time.getTime() < Date.now() - 1 * 24 * 3600 * 1000;
    },
  };
  menuTreeClick = false;
  created() {
    let sidebarWidth = 0;
    let winWidth = document.documentElement.clientWidth;
    window.addEventListener("resize", () => {
      winWidth = document.documentElement.clientWidth;
      this.pageInfoWidth = winWidth - sidebarWidth - 30;
    });
    eventBus.$on("leftSidebar", (v: any) => {
      sidebarWidth = v;
      this.pageInfoWidth = winWidth - v - 30;
    });
    const _t = this as any;
    const date = new Date();
    let month: number | String = date.getMonth() + 1;
    let day: number | String = date.getDate();
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    _t.searchInfo.title = month + "月" + day + "日 - 练习";
    // 课次选择默认选中7天
    const one = 7 * 24 * 3600 * 1000;
    const minTime = new Date().getTime();
    const maxTime = minTime + one;
    _t.expireTime = [minTime, maxTime];
    _t.start_time = parseInt(_t.expireTime[0] / 1000 + "");
    _t.end_time = parseInt(_t.expireTime[1] / 1000 + "");
    _t.globalSearch("", "class");
    // 从时间课表的课次详情跳转过来的数据
    const class_id = _t.$route.query.id;
    const lesson_id = _t.$route.query.lid;
    const queryDate = _t.$route.query.date;
    if (_t.$route.query.id) {
      lessonStudentList({
        class_id: class_id,
        lesson_id: lesson_id,
      }).then((res: any) => {
        if (res.error_code === 0) {
          _t.studentData = res.data.list.filter((item: any) => {
            if (item.student_type === 0) {
              return item;
            }
          });
          _t.allpeople = res.data.list.length;
          _t.jumpList = res.data.list;
          const checkArr: any = [];
          let class_students: any = [];
          _t.searchInfo.type = 2;
          if (checkArr != []) {
            if (_t.searchInfo.type == 1) {
              class_students = _t.mergeArr(res.data.list, "class_id");
            } else {
              class_students = _t.mergeArr(res.data.list, "lesson_id");
            }
            class_students.map((a: any) => {
              if (_t.searchInfo.type == 2) {
                delete a.lesson_id;
              }
            });
            _t.searchInfo.class_students = class_students;
          }
        }
      });
    }
    if (queryDate) {
      _t.expireTime = [
        new Date(queryDate).getTime(),
        new Date(queryDate).getTime(),
      ];
      _t.datechoose(_t.expireTime);
      _t.jumpLessonId = Number(lesson_id);
    }
    this.handleRadioGroup(1);
  }
  beforeDestroy() {
    eventBus.$off("leftSidebar");
    window.removeEventListener("resize", () => {});
  }
  async handleIcon(val: any) {
    this.lessonChildList = [];
    this.lessonId = val.lesson_id;
    this.checkboxDatatwo.map((item: any) => {
      if (item.lesson_id === val.lesson_id) {
        item.showChild = !item.showChild;
      } else {
        item.showChild = false;
      }
      if (item.showChild) {
        lessonStudentList({
          class_id: val.class_id,
          lesson_id: val.lesson_id,
        }).then((res: any) => {
          if (res.error_code === 0) {
            res.data.list.map((item: any) => {
              if (val.checked && item.student_type !== 5) {
                item.ChildChecked = true;
              } else {
                item.ChildChecked = false;
              }
            });
            this.lessonChildList = res.data.list;
          }
        });
      }
    });
  }
  async handleChecked(val: any) {
    this.lessonId = val.lesson_id;
    let selectArr: any = [];
    const allchooseArr: any = [];
    const newArr = JSON.parse(JSON.stringify(this.checkboxDatatwo));
    newArr.map((item: any) => {
      if (item.lesson_id === val.lesson_id) {
        item.checked = val.checked;
        item.showChild = val.checked;
      } else {
        item.checked = false;
        item.showChild = false;
      }
    });
    this.checkboxDatatwo = newArr;
    if (val.checked) {
      await lessonStudentList({
        class_id: val.class_id,
        lesson_id: val.lesson_id,
      }).then((res: any) => {
        if (res.error_code === 0) {
          res.data.list.map((item: any) => {
            if (val.checked && item.student_type !== 5) {
              item.ChildChecked = true;
            } else {
              item.ChildChecked = false;
            }
          });
          this.lessonChildList = res.data.list;
          selectArr = res.data.list;
        }
      });
    } else {
      this.lessonChildList = [];
    }
    selectArr.map((a: any, b: number) => {
      if (a.ChildChecked) {
        allchooseArr.push(a);
      }
    });
    this.allchoose = allchooseArr;
  }
  handleChildChecked(val: any, studentVal: any) {
    // 是否全部选中
    let allTrue = true;
    const newChildArr = JSON.parse(JSON.stringify(this.lessonChildList));
    const allchooseArr = JSON.parse(JSON.stringify(this.allchoose));
    newChildArr.map((item: any, index: number) => {
      if (
        studentVal.ChildChecked &&
        item.student_id === studentVal.student_id
      ) {
        allchooseArr.push(item);
      }
      if (!item.ChildChecked) {
        allTrue = false;
        return;
      }
    });
    this.checkboxDatatwo.map((item: any) => {
      if (!allTrue) {
        if (item.lesson_id === val.lesson_id) {
          item.checked = false;
        }
      } else {
        if (item.lesson_id === val.lesson_id) {
          item.checked = true;
        }
      }
    });
    allchooseArr.map((item: any, ind: number) => {
      if (
        !studentVal.ChildChecked &&
        item.student_id === studentVal.student_id
      ) {
        allchooseArr.splice(ind, 1);
      }
    });
    this.allchoose = allchooseArr;
  }
  handleTeacherSelect(row: any) {
    const copy: any = { ...this.selectedObject };
    if (copy[row.student_id]) {
      delete copy[row.student_id];
    } else {
      copy[row.student_id] = row;
    }
    this.selectedObject = copy;
    const items: any = [];
    for (const key in copy) {
      items.push(copy[key]);
    }
    this.allchoose = items;
    const index = this.checkboxData.findIndex((item: any) => {
      return item.student_id === row.student_id;
    });
    if (index >= 0) {
      this.checkboxData[index].checked = !!copy[row.student_id];
    }
  }
  handleRadioGroup(v: number) {
    if (v === 1) {
      const sevenDay = Date.now() + 6 * 24 * 3600 * 1000;
      this.searchInfo.deadlineTime = dateFormat("YYYY-mm-dd HH", sevenDay);
      this.deadendTime = sevenDay;
    }
  }
  handlePagerChange(e: number) {
    this.classListData({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.classListData({
      page: 1,
      page_size: e,
    });
  }
  // checkchoose(e: any, a: any) {
  //   var _t = this as any;
  //   var array = a.checkedNodes;
  //   var allchoose: any = [];
  //   if (_t.searchInfo.type == 1 && !!e.fristLevel) {
  //     const currentCode = e.class_id;
  //     const current: any = Array.from(_t.$refs.menuTree.$children).filter(
  //       (child: any) => {
  //         return child.node.data.class_id === currentCode;
  //       }
  //     )[0];
  //     current.$el.childNodes[0].childNodes[0].click();
  //   } else if (_t.searchInfo.type == 2 && !!e.fristLevel) {
  //     const currentCode = e.lesson_id;
  //     // const current: any = Array.from(_t.$refs.menuTreetwo.$children).filter(
  //     //   (child: any) => {
  //     //     return child.node.data.lesson_id === currentCode;
  //     //   }
  //     // )[0];
  //     // current.$el.childNodes[0].childNodes[0].click();
  //   }
  //   array.map((a: any, b: number) => {
  //     if (!!a.fristLevel) {
  //     } else {
  //       allchoose.push(a);
  //     }
  //   });
  //   _t.allchoose = allchoose;
  // }
  // 处理发布练习的数据
  mergeArr(arr: any, tagerName: String) {
    const newArr: any = [];
    arr.forEach((item: any) => {
      const dataItem = item;
      if (newArr.length > 0) {
        const filterValue = newArr.filter((v: any) => {
          return v["" + tagerName + ""] == dataItem["" + tagerName + ""];
        });
        if (filterValue.length > 0) {
          newArr.forEach((n: any) => {
            if (n["" + tagerName + ""] == filterValue[0]["" + tagerName + ""]) {
              n.student_ids.push(dataItem.student_id);
            }
          });
        } else {
          let newDataItem: any = {};
          if (tagerName == "lesson_id") {
            newDataItem = {
              lesson_id: dataItem.lesson_id,
              class_id: dataItem.class_id,
              student_ids: [dataItem.student_id],
            };
          } else {
            newDataItem = {
              class_id: dataItem.class_id,
              student_ids: [dataItem.student_id],
            };
          }
          newArr.push(newDataItem);
        }
      } else {
        let newDataItem: any = {};
        if (tagerName == "lesson_id") {
          newDataItem = {
            lesson_id: dataItem.lesson_id,
            class_id: dataItem.class_id,
            student_ids: [dataItem.student_id],
          };
        } else {
          newDataItem = {
            class_id: dataItem.class_id,
            student_ids: [dataItem.student_id],
          };
        }
        newArr.push(newDataItem);
      }
    });
    return newArr;
  }
  datechoose(e: { 0: number; 1: number }) {
    const _t = this as any;
    let expire_start_time: number | String = "";
    let expire_end_time: number | String = "";
    if (e != null) {
      expire_start_time = e[0] / 1000;
      expire_end_time = e[1] / 1000;
    }
    _t.start_time = expire_start_time;
    _t.end_time = expire_end_time;
    _t.getdata();
  }
  confirClick(v: number) {
    const _t = this as any;
    let checkArr: any = [];
    if (_t.searchInfo.type == 1) {
      checkArr = this.allchoose;
    } else {
      checkArr = this.allchoose;
    }
    let class_students: any = [];
    _t.allpeople = 0;
    if (checkArr != []) {
      if (_t.searchInfo.type == 1) {
        class_students = _t.mergeArr(checkArr, "class_id");
      } else {
        class_students = _t.mergeArr(checkArr, "lesson_id");
      }
      class_students.map((a: any) => {
        _t.allpeople += Number(a.student_ids.length);
        if (_t.searchInfo.type == 2) {
          delete a.lesson_id;
        }
        // 传值
        if (v === 1) {
          a.class_id = 0;
          a.lesson_id = 0;
        } else if (v === 2) {
          a.lesson_id = checkArr[0].lesson_id;
        }
      });
      _t.choosestudent = false;
      _t.choosestudenttwo = false;
      _t.searchInfo.class_students = class_students;
    }
  }
  changeInputAgain() {
    const _t = this as any;
    if (_t.searchInfo.type == 1) {
      _t.choosestudent = true;
    } else {
      _t.choosestudenttwo = true;
    }
  }
  changeInput(e: any) {
    const _t = this as any;
    _t.$refs.multiSelect.blur();
    _t.loading = false;
    if (e == 1) {
      _t.choosestudent = true;
      if (_t.checkboxData.length == 0) {
        _t.allchoose = [];
        _t.classListData({
          page: 1,
          page_size: 10,
        });
        _t.checkboxDatatwo = [];
      }
    } else if (e == 2) {
      _t.choosestudenttwo = true;
      if (_t.checkboxDatatwo.length == 0) {
        _t.allchoose = [];
        _t.getlessonList({
          page: 1,
          page_size: 10,
        });
        _t.checkboxData = [];
      }
    }
  }
  load() {
    const _t = this as any;
    if (_t.loading == false) {
      if (_t.searchInfo.type == 1) {
        // // _t.classListPage += 1;
        // _t.classListData({
        //   page: _t.classListPage,
        //   page_size: 10,
        // });
      } else {
        _t.lessionListPage += 1;
        _t.getlessonList({
          page: _t.lessionListPage,
          page_size: 10,
        });
      }
    }
  }
  async loadNode(node: any, res: any) {
    const _t = this as any;
    if (node.level >= 1) {
      const list = await classStudentList({ class_id: node.data.class_id });
      if (list.data.list != []) {
        list.data.list.map((a: any) => {
          a.leaf = true;
        });
      }
      res(list.data.list);
      let checkArr: any = [];
      const newarry: any = [];
      checkArr = _t.$refs.menuTree.getCheckedNodes(true, false);
      if (checkArr != []) {
        checkArr.map((a: any, b: number) => {
          if (!a.fristLevel) {
            newarry.push(a);
          }
        });
      }
      _t.allchoose = newarry;
    }
  }
  async loadNodetwo(node: any, res: any) {
    const _t = this as any;
    if (node.level >= 1) {
      const list = await lessonStudentList({
        class_id: node.data.class_id,
        lesson_id: node.data.lesson_id,
      });
      if (list.data.list != []) {
        list.data.list.map((a: any) => {
          a.leaf = true;
          a.class_name = a.student_name;
          if (a.student_type === 5) {
            a.disabled = true;
          }
        });
      }
      res(list.data.list);
      let checkArr: any = [];
      const newarry: any = [];
      checkArr = _t.$refs.menuTreetwo.getCheckedNodes(true, false);
      if (checkArr != []) {
        checkArr.map((a: any, b: number) => {
          if (!a.fristLevel) {
            newarry.push(a);
          }
        });
      }
      _t.allchoose = newarry;
    }
  }
  getdata() {
    const _t = this as any;
    if (_t.searchInfo.type == 1) {
      _t.classListData({
        page: 1,
        page_size: 10,
      });
    } else {
      _t.getlessonList({
        page: 1,
        page_size: 10,
      });
    }
  }
  classListData(data: any) {
    const _t = this as any;
    data.key_word = _t.class_name;
    data.status = [2];
    _t.loading = true;
    searchStudent(data).then((res: any) => {
      if (res.error_code == 0) {
        _t.total = res.data.total;
        res.data.list.map((it: { checked: boolean; student_id: number }) => {
          if (this.selectedObject[it.student_id]) {
            it.checked = true;
          } else {
            it.checked = false;
          }
        });
        _t.checkboxData = res.data.list;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  getlessonList(data: any) {
    const _t = this as any;
    data.class_id = _t.dialogClassId;
    data.start_time = _t.start_time;
    data.end_time = _t.end_time;
    _t.loading = true;
    lessonList(data).then((res: any) => {
      if (res.error_code == 0) {
        const lid = Number(_t.$route.query.lid);
        if (_t.jumpList.length > 0) {
          _t.allchoose = _t.jumpList;
          const copy: any = { ...this.selectedObject };
          _t.jumpList.map((row: any) => {
            if (copy[row.student_id]) {
              delete copy[row.student_id];
            } else {
              copy[row.student_id] = row;
            }
          });
          this.selectedObject = copy;
          _t.jumpList = [];
        }
        res.data.list.map((item: any) => {
          if (lid && item.lesson_id === lid) {
            item.checked = true;
          } else {
            item.checked = false;
          }
          item.showChild = false;
        });
        if (res.data.list != null) {
          res.data.list.map((a: any) => {
            a.fristLevel = true;
          });
        }
        if (data.page == 1) {
          _t.checkboxDatatwo = res.data.list;
          _t.loading = false;
          return;
        }
        if (res.data.list.length > 0) {
          let checkboxDatatwo = [];
          checkboxDatatwo = res.data.list;
          _t.checkboxDatatwo.push(...checkboxDatatwo);
          _t.loading = false;
        }
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  contentList(e: any) {
    const _t = this as any;
    const newarry = JSON.parse(JSON.stringify(e));
    newarry.map((a: any) => {
      if (a.url) {
        delete a.url;
      }
      if (a.uid) {
        delete a.uid;
      }
      return a;
    });
    _t.searchInfo.content_list = newarry;
  }
  setCoverS(res: any) {
    const _t = this as any;
    _t.searchInfo.images.push(res.data.object);
  }
  delImg(res: any) {
    const _t = this as any;
    _t.searchInfo.images.splice(res, 1);
  }
  // 发布练习
  postData() {
    const _t = this as any;
    if (this.searchInfo.content_list !== undefined) {
      if (
        _t.searchInfo.content_list.filter((item: any) => {
          return item.annex_type === 1;
        }).length > 9
      ) {
        _t.$message({
          type: "warning",
          message: "图片数不能超过9个",
        });
        return;
      }
      if (
        _t.searchInfo.content_list.filter((item: any) => {
          return item.annex_type === 2;
        }).length > 9
      ) {
        _t.$message({
          type: "warning",
          message: "视频数不能超过9个",
        });
        return;
      }
      if (
        _t.searchInfo.content_list.filter((item: any) => {
          return item.annex_type === 4;
        }).length > 9
      ) {
        _t.$message({
          type: "warning",
          message: "音频数不能超过9个",
        });
        return;
      }
    }
    _t.$refs["form"].validate((valid: any) => {
      if (valid) {
        if (_t.searchInfo.publish_type == 1) {
          _t.searchInfo.publish_time = Date.parse(new Date() + "") / 1000;
        }
        if (_t.deadendTime > 0) {
          const num = String(_t.deadendTime).slice(0, 10);
          _t.searchInfo.deadline_time = Number(num);
        }
        if (
          _t.searchInfo.type === 2 &&
          _t.searchInfo.class_students.length > 0
        ) {
          if (_t.searchInfo.class_students[0].lesson_id === undefined) {
            _t.searchInfo.class_students[0].lesson_id = Number(
              this.$route.query.lid
            );
          }
        }
        homeworkAdd(_t.searchInfo).then((res: any) => {
          if (res.error_code == 0) {
            _t.$message({
              type: "success",
              message: "发布成功!",
            });
            _t.goBack();
          } else {
            _t.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      } else {
        return false;
      }
    });
  }
  datechooseClass(e: any) {
    const _t = this as any;
    _t.expireTimeClass = _t.expireTimeClass + ":00" + ":00";
    const time: any = new Date(_t.expireTimeClass);
    const startAt: number | string = (time * 1000) / 1000000;
    _t.searchInfo.publish_time = startAt;
    // 发布时间必须在当前时间之后
    const now = new Date().getTime();
    if (time.getTime() < now) {
      _t.$message({
        type: "warning",
        message: "发布时间必须在当前时间之后",
      });
      _t.expireTimeClass = "";
      return false;
    }
    // 自动设置截止时间
    if (_t.searchInfo.publish_type === 2 && _t.searchInfo.publish_time) {
      const sevenDay = _t.searchInfo.publish_time * 1000 + 6 * 24 * 3600 * 1000;
      _t.searchInfo.deadlineTime = dateFormat("YYYY-mm-dd HH", sevenDay);
      _t.deadendTime = sevenDay;
    }
  }
  dateDeadline(e: any) {
    const time: any = new Date(e + ":00" + ":00").getTime();
    this.deadendTime = time;
  }
  goBack() {
    this.$router.go(-1);
  }
  // 通用搜索框
  getSelectrList(e: string) {
    const _t = this as any;
    _t.globalSearch("", e);
  }
  getglobalsearchdata(data: autoSearchData, type: String) {
    return getSelectClassList(data);
  }
  async globalSearch(queryString: string, type: string) {
    const _t = this;
    let data: autoSearchData = {
      page: 1,
      page_size: 100,
    };
    let restaurants: any = {};
    if (queryString) {
      data = {
        page: 1,
        page_size: 10,
      };
      if (type == "class") {
        data.name = queryString;
      } else if (type == "course") {
        data.title = queryString;
      } else {
        data.key_word = queryString;
      }
    }
    restaurants = await _t.getglobalsearchdata(data, type);
    const list = restaurants.data.list;
    _t.className = list;
  }
  // 通用搜索框结束
}
